import { render, staticRenderFns } from "./TopNavItems.vue?vue&type=template&id=39203d3e"
import script from "./TopNavItems.vue?vue&type=script&lang=js"
export * from "./TopNavItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39203d3e')) {
      api.createRecord('39203d3e', component.options)
    } else {
      api.reload('39203d3e', component.options)
    }
    module.hot.accept("./TopNavItems.vue?vue&type=template&id=39203d3e", function () {
      api.rerender('39203d3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TopNav/TopNavItems.vue"
export default component.exports